import { NavLink } from "react-router-dom";
import saddle_logo from "assets/icons/saddleLogo.svg";
import mob_saddle_logo from "assets/icons/mob_logo.svg";

export default function Logo() {
  return (
    <NavLink to="/">
    <img
      src={saddle_logo}
      alt="logo"
      className="lg:flex w-[180px] lg:w-[143px] lg:h-[55px] xl:w-[232px]  hidden"
    />
    <img
      src={mob_saddle_logo}
      alt="logo"
      className="lg:hidden flex"
    />
  </NavLink>
  );
}